import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet, TouchableOpacity, View } from 'react-native'
import { ProgressBar } from 'react-native-paper'

import { useRouter } from 'expo-router'

import { DS } from '../../../design-system'
import { getDSColorWithOpacity } from '../../../design-system/Palette'
import { useStore } from '../../../models'
import { WalkthroughType } from '../../../models/game/walkthrough'
import { getRouteToLastVisitedTab } from '../../../navigation'
import ArrowLeft from './assets/ArrowLeft.svg'
import Close from './assets/X.svg'
import { useIsEmbeddedSegment } from '@/hooks/useIsEmbeddedSegment'
import { styles as stylesMainHeader } from '@/components/MainHeader/styles'
import { useThrottledCallback } from 'use-debounce'
import { useCheatSheet } from '@/components/CheatSheet/useCheatSheet'

const Titles: Record<WalkthroughType, string> = {
  TableTour: 'Table Tour',
  RaiseOrFold: 'Raise or Fold?',
  DealTheFlop: 'Deal the Flop'
}

export const Top = observer(() => {
  const isEmbedded = useIsEmbeddedSegment()
  const router = useRouter()
  const {
    game: {
      walkthroughProgress,
      walkthroughType,
      isFirstStep,
      goToPreviousStep,
      leaveCurrentGame,
      clearWalkthrough,
      isResponseVisible
    },
    session: { lastVisitedTab }
  } = useStore()
  const { open: openCheatSheet } = useCheatSheet()

  const onOpenCheatSheet = useThrottledCallback(openCheatSheet, 350)

  if (!walkthroughType) return null

  const handleGoBack = async () => {
    clearWalkthrough()
    await leaveCurrentGame(false)
    router.dismissTo(getRouteToLastVisitedTab(lastVisitedTab))
  }

  return !isFirstStep ? (
    <View style={[styles.container]}>
      <View style={styles.content}>
        <View style={styles.leftSide}>
          <TouchableOpacity onPress={goToPreviousStep} style={styles.button}>
            <ArrowLeft />
          </TouchableOpacity>
        </View>

        <DS.Text
          style={{ alignSelf: 'center' }}
          variant={'Body Medium/Medium'}
          textAlign="center"
          color={'Global/White'}
        >
          {Titles[walkthroughType]}
        </DS.Text>

        <View style={[styles.rightSide]}>
          <TouchableOpacity onPress={onOpenCheatSheet} style={styles.button}>
            <DS.Icon name="Key2" size={24} color={'Global/White'} />
          </TouchableOpacity>
          {!isEmbedded && (
            <TouchableOpacity disabled={!isResponseVisible} onPress={handleGoBack} style={styles.button}>
              <Close width={24} height={24} />
            </TouchableOpacity>
          )}
        </View>
      </View>

      <View style={styles.progressBarContainer}>
        <ProgressBar color="#FF3ED4" visible progress={walkthroughProgress} style={styles.progressBarBackground} />
      </View>
    </View>
  ) : null
})

const styles = StyleSheet.create({
  container: {
    // backgroundColor: 'rgba(123, 4, 261, 1)',
    backgroundColor: 'rgba(123, 4, 61, 1)',
    position: 'relative',
    width: '100%',
    zIndex: 10,
    height: 48,
    marginBottom: 24
  },
  content: {
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  leftSide: {
    position: 'absolute',
    left: 8
  },
  rightSide: {
    position: 'absolute',
    right: 8,
    flexDirection: 'row',
    gap: 8
  },
  button: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center'
  },
  progressBarContainer: {
    // flex: 1,
    height: 1,
    width: '100%',
    backgroundColor: 'transparent'
  },
  progressBar: {
    height: 2,
    backgroundColor: getDSColorWithOpacity('Global/Black', 0.5)
  },
  progressBarBackground: {
    height: 2,
    backgroundColor:
      Platform.OS === 'ios' ? getDSColorWithOpacity('Global/Black', 0.5) : getDSColorWithOpacity('Global/White', 0.9)
  }
})
